import PropTypes from 'prop-types';
import React from 'react';

import { throttle } from 'lodash';

// Monitors child component scroll positions
// onElementChange will be called with the key of the child element nearest the top of the viewport
export default class ElementScrollTracker extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            currentElementKey: null,
        };

        // For tracking refs to child components and dom nodes
        this.elementRefs = {};

        this.handleResize = throttle(this.handleResize.bind(this), 100);
        this.handleScroll = throttle(this.handleScroll.bind(this), 100);
    }

    refHandler(child) {
        return ref => {
            if (ref) {
                this.elementRefs[child.key] = {
                    child: child,
                    ref: ref,
                    y: this.getYPosition(ref),
                };
            } else {
                // React passes null ref on unmount
                delete this.elementRefs[child.key];
            }
        };
    }

    render() {
        return (
            <div>
                {React.Children.map(this.props.children, child => {
                    return <div ref={this.refHandler(child)}>{child}</div>;
                })}
            </div>
        );
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
        window.addEventListener('scroll', this.handleScroll);
        this.handleScroll();
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
        window.removeEventListener('scroll', this.handleScroll);
    }

    handleResize() {
        if (this.props.isDisabled) return;

        Object.keys(this.elementRefs).forEach(key => {
            const ref = this.elementRefs[key].ref;
            this.elementRefs[key].y = this.getYPosition(ref);
        });

        this.handleScroll();
    }

    getYPosition(el) {
        const rect = el.getBoundingClientRect();
        return rect.top + document.body.scrollTop;
    }

    handleScroll() {
        if (this.props.isDisabled) return;

        const targetY = window.scrollY;

        const bestElementKey = Object.keys(this.elementRefs).reduce((bestKeySoFar, key) => {
            if (bestKeySoFar === false) {
                return key;
            }

            const bestY = this.elementRefs[bestKeySoFar].y;
            const sectionY = this.elementRefs[key].y;

            const bestDistance = Math.abs(bestY - targetY);
            const sectionDistance = Math.abs(sectionY - targetY);

            if (sectionDistance < bestDistance) {
                return key;
            } else {
                return bestKeySoFar;
            }
        }, false);

        if (bestElementKey && this.state.currentElementKey != bestElementKey) {
            this.setState({ currentElementKey: bestElementKey });
            this.props.onElementChange(bestElementKey);
        }
    }
}

ElementScrollTracker.propTypes = {
    children: PropTypes.node,
    onElementChange: PropTypes.func.isRequired,
    isDisabled: PropTypes.bool.isRequired,
};



// WEBPACK FOOTER //
// ./src/web/js/contest/components/brief/element-scroll-tracker.jsx